export default __webpack_public_path__ + "static/media/d20.430c3fb3.jpg";